
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.828 3.547a.5.5 0 00-.383-.342l-2.349-.45-.45-2.349a.502.502 0 00-.842-.262l-3.32 3.263a.508.508 0 00-.144.282l-.556 3.671-4.144 4.144a.5.5 0 00.708.707l4.144-4.144 3.67-.556a.495.495 0 00.282-.144l3.263-3.32a.501.501 0 00.121-.5zm-3.98 3l-2.997.454.454-2.998 2.535-2.491.338 1.765a.502.502 0 00.397.397l1.765.338-2.492 2.535z"}}),_c('path',{attrs:{"d":"M21.129 8.975a.499.499 0 00-.356.61A9.51 9.51 0 0121.084 12c0 5.22-4.247 9.467-9.467 9.467a9.391 9.391 0 01-4.848-1.351.494.494 0 00-.253-.168c-.008-.002-.016 0-.024-.001C3.884 18.259 2.151 15.33 2.151 12c-.001-5.22 4.245-9.467 9.466-9.467.324 0 .645.016.96.048a.499.499 0 10.101-.995 10.631 10.631 0 00-1.061-.053C5.845 1.533 1.15 6.229 1.15 12c0 3.625 1.854 6.824 4.662 8.703l-.669 2.676a.5.5 0 10.97.242l.596-2.383a10.393 10.393 0 004.909 1.228 10.39 10.39 0 005.161-1.372l.632 2.526a.499.499 0 10.97-.242l-.713-2.852c2.668-1.899 4.418-5.009 4.418-8.526a10.5 10.5 0 00-.344-2.669.498.498 0 00-.61-.356z"}}),_c('path',{attrs:{"d":"M11.617 7.133a.5.5 0 000-1C8.382 6.133 5.75 8.764 5.75 12s2.632 5.866 5.867 5.866a5.874 5.874 0 005.696-7.277.5.5 0 00-.971.24 4.871 4.871 0 01-4.725 6.037c-2.684 0-4.867-2.183-4.867-4.866s2.183-4.867 4.867-4.867z"}})])
          )
        }
      }
    